import axios from 'axios';
import { aiActivity } from './aiActivity';

// A Key "turn" is a POST to /AI (chat, voice, label filter, or the headless report run).
// Tracking in-flight turns lets the app show a global "Key is working" indicator regardless
// of which screen the user is on.
function isAiTurn(config) {
  const url = (config && config.url ? String(config.url) : '').split('?')[0];
  return (config && String(config.method).toLowerCase() === 'post') && url.endsWith('/AI');
}

const axiosInstance = axios.create({
  baseURL: process.env.API_BASE_URL,
  withCredentials: false,
  timeout: 120000,
  paramsSerializer: (params) => {
    return Object.keys(params)
      .map((key) => {
        const value = typeof params[key] === 'object' 
          ? JSON.stringify(params[key]) 
          : params[key];
        return `${key}=${encodeURIComponent(value)}`;
      })
      .join('&');
  }
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth');
  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  } else {
    config.headers.authorization = 'Bearer anonymous';
  }
  if (isAiTurn(config)) { config._aiTurn = true; aiActivity.start(); }
  return config;
});

// Clear the global "Key is working" indicator when a tracked /AI turn finishes (success OR
// error/timeout — so the counter can never leak).
axiosInstance.interceptors.response.use(
  (response) => {
    if (response && response.config && response.config._aiTurn) aiActivity.stop();
    return response;
  },
  (error) => {
    if (error && error.config && error.config._aiTurn) aiActivity.stop();
    return Promise.reject(error);
  },
);

export { axiosInstance };
export default axiosInstance;